import { Layout } from 'react-admin';
import MyAppBar from './MyAppBar';

const MyLayout = (props) => {
    return <Layout {...props} appBar={MyAppBar}
    />;
};

export default MyLayout;